import { DocType } from "@app/enums/doc-type";

export interface DocsLicense {
  attributes: Attributes;
  Id: string;
  Name: string;
  DocumentType__c: DocType;
  Url__c: string;
  UsuarioArc__c: string;
  UploadDate__c: Date;
  Lead__c: string;
  Status__c: string;
  Verified__c: string;
  InternalCompany__c: string;
}

interface Attributes {
  type: string;
  url: string;
}
